import { createSelector, Selector } from 'reselect';
import { RootState } from '../root-reducer';
import { MessagesExpandedReturnTarget } from './types';

export const appConfiguratorStateSelector = (state: RootState) => state.appConfigurator;

export const floatingMessageModalOpenSelector: Selector<RootState, boolean> = createSelector(
    [appConfiguratorStateSelector],
    config => config.floatingMessageModalOpen ?? false,
);

export const isMessageModalExpandedSelector = createSelector(
    [appConfiguratorStateSelector],
    config => config.isMessageModalExpanded ?? false,
);

export const avatarMessageOpenSelector = createSelector(
    [appConfiguratorStateSelector],
    config => config.avatarMessageOpen ?? false,
);

export const messagesExpandedReturnTargetSelector: Selector<
    RootState,
    MessagesExpandedReturnTarget | undefined
> = createSelector([appConfiguratorStateSelector], config => config.messagesExpandedReturnTarget);
